import { RichTextProps } from '@src/quince-components/src/index'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import RichText from '@src/quince-site-common/src/domains/RichText'

import styles from './rowOfImageTextBlocks.module.scss'

export const makeRichTextProps = (sectionDetails: CustomSection): RichTextProps | undefined => {
  if (sectionDetails.richTexts && sectionDetails.richTexts.length > 0) {
    const richText = sectionDetails.richTexts[0]
    return RichText.makeRichTextProps(richText)
  }

  return
}

export const getBlockContainerClassName = (sectionDetails: CustomSection): string | undefined => {
  const subsections = sectionDetails.subSections
  if (subsections?.length && subsections?.length >= 2 && subsections?.length <= 4) {
    const columnsClassName = `blocksContainer_${subsections.length}`
    return `${styles.blocksContainer} ${styles[columnsClassName]}`
  }

  return
}

export const isRowOfImageTextBlocksSectionDataValid = (section: CustomSection | undefined) => {
  if (!section) {
    return false
  }

  const areSubSectionsValidLength = (section?.subSections || []).length >= 2 || (section?.subSections || []).length <= 4

  const areValidImagesPresent =
    (section?.subSections || []).filter(ss => {
      const areImagesPresent = ss.images?.length && ss.images?.length > 0
      const isImageValid = ss.images?.[0]?.url
      // Filter out the ss if any of conditions don't match
      return !areImagesPresent || !isImageValid
    }).length === 0 // No invalid ss should be present

  return areSubSectionsValidLength && areValidImagesPresent
}
